import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import NewTagTypeForm from './NewTagTypeForm';

const NewTagForm = ({ completeTagData, tagTypeData, onAddTag }) => {
  const [showAddOption, setShowAddOption] = useState(false);
  const [tagTypeOptions, setTagTypeOptions] = useState([]);
  const [newTagTagTypes, setNewTagTagTypes] = useState([]);
  const [newTagName, setNewTagName] = useState('');
  const [alert, setAlert] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (tagTypeData) {
      const defaults = tagTypeData.map(tagType => ({
        ...tagType,
        isChecked: false
      }));
      setTagTypeOptions(defaults);
    }
  }, [tagTypeData]);

  const toggleAddOption = (event) => {
    event.preventDefault();
    setNewTagName('')
    setShowAddOption(!showAddOption);
    setTagTypeOptions((prev) =>
      prev
        .filter((tag) => tag.id !== 0)
        .map((tag) => ({ ...tag, isChecked: false }))
    );
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setNewTagName(value);

    if (!tagTypeOptions.some(tagType => tagType.isChecked)) {
      setAlert('Select at least one tag type.');
    }

    if (completeTagData.some(tag => tag.name.toLowerCase() === value.toLowerCase())) {
      setError('This tag already exists.')
    } else if (error) {
      setError('')
    }
  };

  const handleTypeToggle = (checkedTagType) => {
    const updatedTagTypeOptions = tagTypeOptions.map(tagType =>
      tagType.type === checkedTagType.type
        ? { ...tagType, isChecked: !tagType.isChecked }
        : tagType
      )
      .filter(tagType => !(tagType.type === checkedTagType.type && !tagType.isChecked))

    setTagTypeOptions(updatedTagTypeOptions);

    const updatedTagType = {
      ...checkedTagType,
      isChecked: !checkedTagType.isChecked
    }
    let updatedNewTagTagTypes
    if (updatedTagType.isChecked) {
      updatedNewTagTagTypes = newTagTagTypes.concat(updatedTagType)
    } else {
      updatedNewTagTagTypes = newTagTagTypes.filter(tagTagType => tagTagType !== checkedTagType)
    }
    setNewTagTagTypes(updatedNewTagTagTypes)

    if (!updatedTagTypeOptions.some(tagType => tagType.isChecked)) {
      setAlert('Select at least one tag type.');
    } else {
      setAlert('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (tagTypeOptions.some(tagType => tagType.isChecked)) {
      const newTagTagTypes = tagTypeOptions
      .filter(tagTypeObject => tagTypeObject.isChecked)
      // eslint-disable-next-line no-unused-vars
      .map(({ isChecked, ...rest }) => rest);
  
      onAddTag(newTagName, newTagTagTypes);
      setNewTagName('')
      setShowAddOption(false)
      setTagTypeOptions((prev) =>
        prev.map((tag) => ({ ...tag, isChecked: false }))
      );
    }
  };

  const handleKeyDown = (e, tagType) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleTypeToggle(tagType);
    }
  };
  
  const handleAddTagType = async (newTagType) => {
    setTagTypeOptions((prev) => [...prev, newTagType])
    setAlert('');
  };

  return (
    <div>
    <button onClick={toggleAddOption}>
      {showAddOption ? 'Cancel New Tag' : 'Create New Tag'}
    </button>
    {showAddOption && (
      <form>
        <label htmlFor="newTagName">New Tag:</label>
        <input
          type="text"
          value={newTagName}
          onChange={handleInputChange}
          placeholder="Enter a new tag here"
        />
        <span>
          {newTagName && (
            <div>{error && (<div style={{ color: 'red' }}>{error}</div>
            )}
              <div>
                <label>{`Tag Types:`}</label>
                <div>
                  {tagTypeOptions.length > 0 ? (
                    tagTypeOptions.map(tagType => (
                      <div key={tagType.type}>
                        <label>
                          <input
                            type="checkbox"
                            checked={tagType.isChecked}
                            onChange={() => handleTypeToggle(tagType)}
                            onKeyDown={(e) => handleKeyDown(e, tagType)}
                            />
                          {tagType.type}
                        </label>
                      </div>
                    ))
                  ) : (
                    <div style={{ color: 'red' }}>No Tag Types Found</div>
                  )}
                </div>
                <NewTagTypeForm tagTypeOptions={tagTypeOptions} onAddTagType={handleAddTagType}/>
                {alert && (<div style={{ color: 'yellow' }}>{alert}</div>)}
                <button onClick={handleSubmit} disabled={alert || error}>Create Tag</button>
              </div>
            </div>
          )}
        </span>
      </form>
    )}
    </div>
  );
};

NewTagForm.propTypes = {
  completeTagData: PropTypes.array.isRequired,
  tagTypeData: PropTypes.array,
  onAddTag: PropTypes.func.isRequired,
};

export default NewTagForm;
